import { inject, observer } from 'mobx-react';
import React from 'react';
import { IInjectedProps } from '../../../types';
import IconNovelty from '../../icons/icon_novelty';
import styles from './eyeCatcher.scss';

export const EyeCatcher = inject('store')(
    observer(({ store }: IInjectedProps) => {
        if (!store)
            return null;

        return (
            <div data-testid='eye_catcher' data-semantic-id='eye_catcher' className={styles.eye_catcher}>
                {store.mixedMediaStore.isNew && <div data-testid='eye_catcher_is_new'
                  data-semantic-id='eye_catcher_is_new' className={styles.ec_is_new}>
                    <span className={styles.inner_text_area}>
                        {store.mixedMediaStore.mainStore.localization.isNew}
                    </span>
                    <span className={styles.star_icon}><IconNovelty /></span>
                    </div>}
            </div>
        );
    })
);

